import { createFileRoute } from "@tanstack/react-router";
import AdminCarMaxImages from "@/pages/admin/AdminCarMaxImages";

export const Route = createFileRoute("/_adminLayout/admin/carmax-images")({
  component: AdminCarMaxImages,
});
